export class GetDirectoryEntityRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "entityId",
            "baseName": "entityId",
            "type": "string",
            "format": ""
        },
        {
            "name": "entityType",
            "baseName": "entityType",
            "type": "DirectoryEntityType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetDirectoryEntityRequest.attributeTypeMap;
    }
    constructor() {
    }
}
